import { useDispatch, useSelector } from 'react-redux';
import { selectUserProfile } from 'app/pages/Layout/slice/selectors';
import { useCommentSlice } from '../CommentState';
import { generateTimestamp } from '../helper';
import { selectSelectedSection, selectCommunicationMode } from '../CommentState/selectors';

export const useEditHandlers = () => {
  const loggedInUser = useSelector(selectUserProfile);
  const sectionData = useSelector(selectSelectedSection);
  const communicationMode = useSelector(selectCommunicationMode);
  const dispatch = useDispatch();
  const { actions } = useCommentSlice();

  // Handle edit operations for both comments and replies
  const handleEdit = (params: any) => {
    if (!params?.wasChanged) return;
    const hasMentions = params.commentMentions && (params.commentMentions.length > 0);
    if (params.id === params.parentCommentId) {
      dispatch(
        actions.editComment({
          commentId: params.parentCommentId,
          text: params.text,
          commentMentions: params.commentMentions,
          userId: loggedInUser.uid,
          editedAt: generateTimestamp(),
          commentType: 'MAIN COMMENT',
          section: sectionData?.sectionLabel || sectionData?.item.label,
          sectionCategory: sectionData?.item.label || 'No Section Category',
          communicationMode: hasMentions ? communicationMode : null
        })
      );
    } else {
      // Handle reply editing
      dispatch(
        actions.editReply({
          commentId: params.parentCommentId,
          text: params.text,
          commentMentions: params.commentMentions,
          userId: loggedInUser.uid,
          editedAt: generateTimestamp(),
          commentReplyId: params.id,
          commentType: 'REPLY',
          section: sectionData?.sectionLabel || sectionData?.item.label,
          sectionCategory: sectionData?.item.label || 'No Section Category',
          communicationMode: hasMentions ? communicationMode : null
        })
      );
    }
  };

  return {
    handleEdit
  };
};
